class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.content = this.detailsContainer.querySelector('.modal__content');
    this.isHeaderSearch = this.classList.contains('header__search');
    this.closeTimer = null;
    this.closeOnScroll = this.closeOnScroll.bind(this);

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    clearTimeout(this.closeTimer);
    this.closeHeaderOverlays();
    event.target.closest('details').setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', true);

    requestAnimationFrame(() => {
      this.detailsContainer.classList.add('menu-opening');
    });

    document.body.addEventListener('click', this.onBodyClickEvent);
    if (!this.isHeaderSearch) document.body.classList.add('overflow-hidden');
    if (this.isHeaderSearch) this.bindScrollClose();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.detailsContainer.hasAttribute('open')) return;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.summaryToggle.setAttribute('aria-expanded', false);
    this.detailsContainer.classList.remove('menu-opening');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.unbindScrollClose();

    if (!this.isHeaderSearch) {
      this.detailsContainer.removeAttribute('open');
      return;
    }

    clearTimeout(this.closeTimer);

    const removeOpen = () => {
      this.content.removeEventListener('transitionend', onTransitionEnd);
      this.detailsContainer.removeAttribute('open');
    };

    const onTransitionEnd = (event) => {
      if (event.target !== this.content || event.propertyName !== 'transform') return;
      clearTimeout(this.closeTimer);
      removeOpen();
    };

    this.content.addEventListener('transitionend', onTransitionEnd);
    this.closeTimer = setTimeout(removeOpen, 500);
  }

  closeHeaderOverlays() {
    if (!this.isHeaderSearch) return;

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (typeof menu.close === 'function') menu.close();
    });

    document.querySelectorAll('details-modal.header__search').forEach((modal) => {
      if (modal !== this && typeof modal.close === 'function') modal.close(false);
    });
  }

  bindScrollClose() {
    window.addEventListener('scroll', this.closeOnScroll, { passive: true });
    window.addEventListener('wheel', this.closeOnScroll, { passive: true });
    window.addEventListener('touchmove', this.closeOnScroll, { passive: true });
  }

  unbindScrollClose() {
    window.removeEventListener('scroll', this.closeOnScroll);
    window.removeEventListener('wheel', this.closeOnScroll);
    window.removeEventListener('touchmove', this.closeOnScroll);
  }

  closeOnScroll() {
    this.close(false);
  }
}

customElements.define('details-modal', DetailsModal);
